function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// @ts-strict-ignore
import clsx from 'clsx';
import * as React from 'react';
import { isTestEnv } from 'common/report/util/env';
import { ReportMessageBannerReact } from 'common/widgets/report-message-banner';
import { ReportBannersReact } from 'common/widgets/report-banners';
import { getDownloadModeFromLocation } from 'common/report/util';
import { DownloadMode } from 'common/report/constants';
import { useReportLayoutManager } from 'common/contexts/react/report-layout-manager-context';
import styles from './index.module.styl';
export const HORIZONTAL_CONTENT_PADDING_STYLE = "32px";
type BannerLayoutProps = React.PropsWithChildren<{
  className?: string;
  id?: string;
  revealedBannerIdentifiers?: Set<string>;
  onBannerLayoutResized?: (_: {
    padding: number;
  }) => void;
  excludePaddings?: {
    banner?: boolean;
    app?: boolean;
  };
  style?: React.CSSProperties;
}>;

/**
 * BannerLayout functionality:
 * - Adds banners to the top of reports
 * - Is the scroll container for most reports. (It is not used as the scroll container for core reports, since they
 *  have different scroll behavior.)
 * - Adds standardized padding to reports.
 */
export const BannerLayout: React.FC<BannerLayoutProps> = (props: BannerLayoutProps) => {
  var _props$excludePadding, _props$excludePadding2;
  const downloadMode = getDownloadModeFromLocation();
  const reportLayoutManager = useReportLayoutManager();
  if (downloadMode !== DownloadMode.None) {
    return <div className={props.className}>{props.children}</div>;
  }
  const contentScrollerRef = React.useRef<HTMLDivElement>();
  React.useEffect(() => {
    if (contentScrollerRef.current) {
      reportLayoutManager.updateScrollContainer(contentScrollerRef.current);
    }
  }, [contentScrollerRef.current]);
  return <div id={props.id} className={clsx(styles.bannerLayout, props.className, "inherit-size")} data-sentry-component="BannerLayout" data-sentry-source-file="index.tsx">
      <div id={props.id} className={clsx(styles.contentScroller, "inherit-size", {
      [styles.excludeAppPadding]: (_props$excludePadding = props.excludePaddings) === null || _props$excludePadding === void 0 ? void 0 : _props$excludePadding.app,
      [styles.excludeBannerPadding]: (_props$excludePadding2 = props.excludePaddings) === null || _props$excludePadding2 === void 0 ? void 0 : _props$excludePadding2.banner
    })} style={_objectSpread(_objectSpread({}, props.style), {}, {
      '--horizontal-padding': HORIZONTAL_CONTENT_PADDING_STYLE
    })} elref={"contentScroller"} ref={contentScrollerRef}>
        {!isTestEnv() &&
      // only show banners if it's not test env, since some test suites aren't setup to mock banner
      // API requests
      <div className={styles.bannerContainer}>
            <ReportMessageBannerReact />
            <ReportBannersReact revealedBannerIdentifiers={props.revealedBannerIdentifiers} />
          </div>}
        {props.children}
      </div>
    </div>;
};